module.exports = __webpack_public_path__ + "img/proList2_27_09.8861a085.jpg";